import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18next from './i18next';
import 'whatwg-fetch';

import ConsentModal from './ConsentsLoginModal';
import PrivacySettings from './UserSettings/privacySettingsApp';

if (process.env.NODE_ENV !== 'production') {
    require('Theme/less/base.less');
}

export var initConsentModal = function(lng, applicationName) {
    if (lng) {
        i18next.changeLanguage(lng);
    }

    const consentModalContainer = document.getElementById(
        'flowui-injected-utils-consent-modal'
    );
    if (consentModalContainer) {
        return ReactDOM.render(
            <I18nextProvider i18n={i18next}>
                <ConsentModal applicationName={applicationName}/>
            </I18nextProvider>,
            consentModalContainer
        );
    }
    return null;
};

export var initPrivacySettings = function(lng) {
    if (lng) {
        i18next.changeLanguage(lng);
    }

    const userSettingsContainer = document.getElementById(
        'flowui-injected-utils-privacy-settings'
    );
    if (userSettingsContainer) {
        return ReactDOM.render(
            <I18nextProvider i18n={i18next}>
                <PrivacySettings/>
            </I18nextProvider>,
            userSettingsContainer
        );
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/index.js